export const download = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.334 15.11L5.27827 10.0557L6.2897 9.02714L9.6197 12.3571V0H11.0483V12.3571L14.3768 9.02857L15.3897 10.0557L10.334 15.11ZM2.64256 20C1.98446 20 1.43541 19.78 0.995413 19.34C0.555413 18.9 0.334937 18.3505 0.333984 17.6914V14.23H1.76256V17.6914C1.76256 17.9114 1.85398 18.1133 2.03684 18.2971C2.2197 18.481 2.42113 18.5724 2.64113 18.5714H18.0268C18.2459 18.5714 18.4473 18.48 18.6311 18.2971C18.8149 18.1143 18.9064 17.9124 18.9054 17.6914V14.23H20.334V17.6914C20.334 18.3495 20.114 18.8986 19.674 19.3386C19.234 19.7786 18.6845 19.999 18.0254 20H2.64256Z"
      fill="white"
    />
  </svg>
);
